import { DialogButton, TodoPrioIcon } from "arkh";
import { PRIORITIES, TodoPriorityValue } from "../TodoPriorities";

import { FormattedMessage } from "react-intl";

export function TodoToolbarButtonPrio(props: {
  prio: TodoPriorityValue | undefined;
  onPress: () => void;
  isLocked: boolean;
}) {
  if (!props.prio || props.prio === "DEFAULT") {
    return (
      <DialogButton
        mode="inactive"
        onPress={props.onPress}
        indicatorIcon="prio"
      >
        <FormattedMessage
          defaultMessage="Priority"
          description="Todo Toolbar Button Priority Title"
        />
      </DialogButton>
    );
  }
  const selectedPriority = PRIORITIES.find((p) => p.value === props.prio);

  if (!selectedPriority) {
    return null;
  }

  return (
    <DialogButton
      mode={props.isLocked ? "locked-active" : "active"}
      onPress={props.onPress}
      indicatorComponent={<TodoPrioIcon priority={props.prio} />}
    >
      {selectedPriority.label}
    </DialogButton>
  );
}
